//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    skuPrefix: { type: String, required: true },
    relatedProducts: { type: Array, required: true }
  },
  computed: {
    ...mapGetters({
      getProductName: 'product/productName'
    }),
    options () {
      return (this.relatedProducts || []).map(
        product => ({
          sku: product.sku,
          name: this.getProductName(product.sku, false),
          target: product.url,
          icon: product.icon,
          isCurrent: product.sku === this.skuPrefix
        })
      )
    }
  }
}
